module.exports = __webpack_public_path__ + "img/video2-placeholder.d664b50d.jpg";